import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { eventApi } from "../api/eventApi";
import { PAGINATION } from "../constants/common";

export const useEvents = (params) => {
  const queryKey = ["/events", params];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await eventApi.getAll(params),
  });

  const remove = useMutation({
    mutationFn: async (id) => await eventApi.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || PAGINATION,
    total: data?.pagination.total || 0,
    loading: isLoading,
    error,
    remove,
  };
};

export const useEvent = (id) => {
  const queryKey = ["/event", id];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await eventApi.getById(id),
    enabled: !!id && id !== "create",
  });

  const create = useMutation({
    mutationFn: async (body) => await eventApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async ({ id, body }) => await eventApi.update(id, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data,
    loading: isLoading,
    error,
    create,
    update,
  };
};
